/**
 * dh-r-reveal.js — DermaHabits refresh scroll-reveal observer.
 *
 * Watches elements with class .dh-r-fade-up or .dh-r-fade-in and adds the
 * .dh-r-in class when they enter the viewport, triggering CSS transitions
 * defined in assets/base.css.
 *
 * Stagger via .dh-r-d1 .. .dh-r-d5 classes (CSS transition-delay).
 *
 * Respects prefers-reduced-motion: reveals immediately (no animation).
 *
 * Self-initializing on DOMContentLoaded; also re-runs on Shopify section
 * load events so theme editor previews work.
 */
(function () {
  'use strict';

  var SELECTOR = '.dh-r-fade-up, .dh-r-fade-in';
  var IN_CLASS = 'dh-r-in';
  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    var els = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add(IN_CLASS);
    }
  }

  function observe(root) {
    if (!('IntersectionObserver' in window)) {
      revealAll(root);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(IN_CLASS);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    var els = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      io.observe(els[i]);
    }
  }

  function init(root) {
    if (prefersReduced) {
      revealAll(root);
    } else {
      observe(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-run on Shopify section reloads (theme editor preview)
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
